import { action, computed, observable, set } from 'mobx';
import { addToMap, Contract, HttpClient, setMap } from 'Mri.Web.Common';

export class ContractsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync(cache = false) {
        const contracts = await this.httpClient.get<Mri.Contracts.Contract[]>(`/api/v1/contracts`, {
            cache,
        });

        if (contracts)
            setMap(
                this.contracts,
                contracts.map(c => new Contract(c)),
                c => c.serviceCO
            );
    }

    @action
    public async loadAccountContractsAsync(accountNumber: string) {
        const contracts = await this.httpClient.get<Mri.Contracts.Contract[]>(
            `/api/v1/accounts/${accountNumber}/contracts`
        );

        if (contracts)
            addToMap(
                this.contracts,
                contracts.map(c => new Contract(c)),
                c => c.serviceCO
            );
    }

    @action
    public async loadAsync(serviceCO: string, cache = false) {
        const contract = await this.httpClient.get<Mri.Contracts.Contract>(`/api/v1/contracts/${serviceCO}`, {
            cache,
        });

        if (contract) this.contracts.set(contract.serviceCO, new Contract(contract));
    }

    @computed
    public get accountContracts(): Map<string, Contract[]> {
        const accountContracts = Array.from(this.contracts, ([k, v]) => v).reduce((r, c) => {
            if (!r.has(c.accountNumber)) r.set(c.accountNumber, []);
            r.get(c.accountNumber)!.push(c);
            return r;
        }, new Map<string, Contract[]>());

        return accountContracts;
    }

    @observable
    public contracts = new Map<string, Contract>();
    private readonly httpClient: HttpClient;
}
